export default __webpack_public_path__ + "static/media/loaderGreenBiz.29828313.png";